export const BLUE: string = "#0000ff";
export const RED: string = "#ff0000";
export const YELLOW: string = "#ffff00";
export const COLORS: string[] = [BLUE, RED, YELLOW];
